<template>
    <div v-if="typeusers.length != 0" class="wrapper">
        <item-form
                :model="model"
                :typeusers="typeusers"
                :bedrijven="bedrijven"
                :isEditing="false"
                @save-item="addItem">
        </item-form>

        <b-modal title="Toevoegen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Account werd niet toegevoegd! {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/account';
    import ItemForm from './Form';
    import datefunctions from '../../helpers/datefunctions';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                typeusers: [],
                bedrijven: [],
                model: {
                    tuinderbedrijf_n: [],
                },
            };
        },
        created () {
            api.getDetailUser(0).then((response) => {
                this.typeusers = response.data.typeusers;
                this.bedrijven = response.data.bedrijven;
            });
        },
        mounted () {
            this.model.begindatum = datefunctions.currentDateYYYYMMDD();
            this.model.einddatum = datefunctions.currentDatePlus10YYYYMMDD();
        },
        methods: {
            addItem (model) {
                api.addUser(model).then(() => {
                    this.$router.replace('/beheer/account');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/account/New.vue